import { IRequesterInfo } from '../../../../base/models'
import { ClientProxy } from '../../../../base/proxy/clientProxy'
import { KvkkDeclarationFile } from '../models/models'

export class GetCreditCardDeclarationApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'dealer/creditCardDeclaration',
      requesterInfo,
    })
  }

  public async getDeclaration(id: number): Promise<KvkkDeclarationFile> {
    return await this.getAsync<KvkkDeclarationFile>(String(id))
  }
}
